import React from "react";

import CopiedIcon from "@uui/CheckSquare";

import { FloatingNavButton } from "@app/analytics/components/reports/FloatingNav";
import * as Events from "@app/analytics/tracking/events";
import { CopyIcon } from "@app/common/assets/icons";
import useCopyToClipboard from "@app/common/hooks/useCopyToClipboard";

import CopyButton from "@rui/CopyButton";
import MenuItem from "@rui/MenuItem";

const CopyNotesMenuItem = ({ content }: { content: string }) => {
  const { copyToClipboard } = useCopyToClipboard();
  const handleClick = () => {
    copyToClipboard(content);
  };

  return (
    <MenuItem icon={<CopyIcon />} onClick={handleClick}>
      Copy notes
    </MenuItem>
  );
};

const CopyNotes = ({
  content,
  variant,
}: {
  content: string;
  variant: "button" | "menu";
}) => {
  const logCopy = () => {
    Events.copyToClipboard({ name: "notes-copy" });
  };

  if (variant === "button") {
    return (
      <CopyButton
        tooltip="Copy notes"
        copyValue={content}
        onClick={logCopy}
        renderIconButton={({ onClick }, copied) => (
          <FloatingNavButton
            onClick={onClick}
            Icon={copied ? CopiedIcon : CopyIcon}
          >
            {copied ? "Copied!" : "Copy"}
          </FloatingNavButton>
        )}
      />
    );
  }

  return <CopyNotesMenuItem content={content} />;
};

export default CopyNotes;
